export default function formatTagsAsOptions(ordered, entityType) {
  const options = [];

  let tagCount = 1;
  const tagOrder = new Map();

  ordered.__order.forEach((type) => {
    const isSystem = type === 'system';

    ordered[type].__order.map((uuid) => {
      const category = ordered[type][uuid];
      const isPrimary = uuid === 'primary';
      const tags = [];

      category.tags.__order.forEach((uuid) => {
        const tag = category.tags[uuid];
        const isApplicable =
          category.tags[uuid]?.__taggables_set.has(entityType);
        const isEnabled = !tag.is_disabled;
        if (isApplicable && isEnabled) {
          const { color, name, description, order } = tag;
          tags.push({
            id: uuid,
            value: uuid,
            order,
            properties: {
              color,
              description,
              name,
            },
          });
          tagOrder.set(uuid, tagCount);
          tagCount += 1;
        }
      });

      if (tags.length) {
        const name = isSystem && isPrimary ? 'Beamible' : category.name;
        const id = isSystem ? 'beamible' : uuid;
        options.push({
          id,
          name,
          categorise: !isPrimary,
          options: tags,
        });
      }
    });
  });

  return { options, tagOrder };
}
